import React from 'react';

import './index.scss';

//materila-ui
import { CircularProgress } from '@material-ui/core';

//api
import {api} from '../../functions/api';

//custom components
import CustomTable from '../../components/complex/customTable';
import Search from '../../components/basic/search';
import CustomButton from '../../components/basic/CustomButton';
import DeleteDialog from '../../components/global/deleteDialog';
import AddEditDeliveryType from './AddEdit';
import AddEditWeightCategory from './AddEditWeightCategory';

//other libraries
import {toJS} from 'mobx';
import queryString from 'query-string'
import { inject, observer } from 'mobx-react';
import Icon from '@mdi/react'
import {mdiPlus} from '@mdi/js'


@inject('internal')
@inject('translate')
@observer
export default class Delivery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
            searchTerm: "",
            openAddDialog: false,
        }
    }

    componentDidMount() {
        if(toJS(this.props.internal.user)
            && toJS(this.props.internal.user.data)
            && toJS(this.props.internal.user.data.permissions)
            && toJS(this.props.internal.user.data.permissions.lists_delivery_types)
            && toJS(this.props.internal.user.data.permissions.lists_delivery_types.view)){

            this.loadDeliveryTypes();
            this.props.internal.setRoute(this.props.history, this.props.location.pathname);

            const URLqueryString = this.props.history.location.search
            let queries = queryString.parse(URLqueryString);

            let searchterm;
            if(queries) {
                if(queries.searchterm) {
                    searchterm = queries.searchterm
                    this.setState({searchTerm: searchterm})
                }
            }

            this.setPermissions();
        }
        else {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname)
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    tableHeader = [
        {
            "title": "name",
            "numeric": false,
            "min_width": "100px"
        },
        {
            "title": "price",
            "numeric": true,
        },
        {
            "title": "free_from",
            "numeric": true,
        },
        {
            "title": "production",
            "numeric": false,
            textAlign: "center"
        },
    ];
    tableBody = ["name", "price", "free_from", "production"]

    dropDownMenuItems = [
        
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
        //     action: "edit"
        // },
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT_WEIGHT,
        //     action: "edit_weight"
        // },
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
        //     action: "delete"
        // },
    ]

    setPermissions () {
        this.dropDownMenuItems = []
        let permissions = toJS(this.props.internal.user.data.permissions.lists_delivery_types);
        if(permissions.update) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
                    action: "edit"
                },
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT_WEIGHT,
                    action: "edit_weight"
                },
            )
        }

        if(permissions.destroy) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
                    action: "delete"
                },
            )
        }

    }

    loadDeliveryTypes = async (size = 10, page = 0, searchterm = " ", by = "name", dir = "asc") => {

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {
            
            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }
        }

        let params = {
            searchterm: searchterm,
            page: {
                number: page,
                size: size
            },
            order: [
                {
                    by: by,
                    dir: dir
                }
            ]
        }


        let load_data = await api({
            method: 'get',
            url: 'lists/delivery-types',
            authorization: this.props.internal.user.access_token,
            params: params
        })

        if(load_data.success === true) {
            this.props.internal.setDataForTable(load_data.data)
        }
        else {

        }

        this.setState({loading: false})
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = (searchTerm) => {

        if (searchTerm.length > 2) {
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else{
            this.addQueryToUrl("searchterm", "")
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
        // this.addQueryToUrl("by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key && queries[key] !== "") {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadDeliveryTypes()
    }

    createNewDeliveryType = () => {
        this.setState({openAddDialog: true})
    }
    
    handleDelete = async () => {
        let idDeliveryType = toJS(this.props.internal.actionDeleteObj.id)
        let delete_delivery_type = await api({
            method: 'delete',
            url: `lists/delivery-types/${idDeliveryType}`,
            authorization: this.props.internal.user.access_token,
        });

        if(delete_delivery_type.success === true) {
            this.props.internal.setSnackbar(delete_delivery_type.data.message, true)
            this.loadDeliveryTypes();
            this.props.internal.setActionDelete();
        }
        else {

        }
    }

    closeAddDialog = () => {
        this.setState({openAddDialog: false});
        
    }

    closeDialog = () => {
        let data = {
            edit: false,
            id: null
        }
        this.props.internal.setActionEdit(data);
        this.props.internal.setActionEdit2(data);
        this.setState({openAddDialog: false})
        this.loadDeliveryTypes()
    }

    clickOnProductionStatus = async(id, status) => {
        this.setState({loading: true})
        let update_data = await api({
            method: 'patch',
            url: 'lists/delivery-types/' + id,
            authorization: this.props.internal.user.access_token,
            params: {
                production: status,
            }
        })
        
        if(update_data.success === true) {
            await this.loadDeliveryTypes()
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.setState({loading: false})
        }
        else {
            let resultError = "";
            if(update_data.data.data.errors) {
                for(let error in update_data.data.data.errors){
                    resultError += update_data.data.data.errors[error] + " "
                }
            }
            this.props.internal.setSnackbar( resultError, true)
            this.setState({loading: false})
        }
        
    }

    render() {
        let permissions = toJS(this.props.internal.user.data.permissions.lists_delivery_types);
        return (
            this.state.loading
                ?
                <CircularProgress className = {'circular-progress'}/>
                :
                <div className={'delivery-container'}>
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES.TRANSPORTS.DELETE_TRANSPORT_TYPE_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />
                    {/* CREATE NEW */}
                    <AddEditDeliveryType
                        open={this.state.openAddDialog}
                        onClose={this.closeAddDialog}
                        title={this.props.translate.i18n.MODULES.TRANSPORTS.NEW_DELIVERY_TYPE_TITLE}
                        onClose={this.closeDialog}
                    />
                    {/* EDIT DELIVERY TYPE */}
                    {this.props.internal.actionEdit.edit ?
                        <AddEditDeliveryType
                            open={this.props.internal.actionEdit.edit}
                            onClose={this.closeAddDialog}
                            title={this.props.translate.i18n.MODULES.TRANSPORTS.EDIT_DELIVERY_TYPE_TITLE}
                            onClose={this.closeDialog}
                        />
                        :
                        null
                    }
                     {/* EDIT WEIGHT  */}
                     {this.props.internal.actionEdit2.edit ?
                        <AddEditWeightCategory
                            open={this.props.internal.actionEdit2.edit}
                            onClose={this.closeAddDialog}
                            title={this.props.translate.i18n.MODULES.TRANSPORTS.EDIT_WEIGHT_CATEGORIES}
                            onClose={this.closeDialog}
                        />
                        :
                        null
                    }
                    <div className={'flex space-between'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.TRANSPORTS.SEARCH} classes={'products-search-box'} onChange={this.handleSearch} value={this.state.searchTerm }/>
                        {permissions.store ?
                            <CustomButton
                            mystyle={'btn-orange-bg border-radius-18'}
                                title={this.props.translate.i18n.MODULES.TRANSPORTS.CREATE_NEW_TRANSPORT_TYPE}
                                onClick={this.createNewDeliveryType}
                            >
                                <Icon path={mdiPlus} size={1}  />
                            </CustomButton>
                            :
                            null
                        }
                    </div>
                    <CustomTable
                        dropDownMenuItems = {this.dropDownMenuItems}
                        module = {'/transports'}
                        handleChangeRowsPerPage = {this.handleChangeRowsPerPage}
                        handleChangePage = {this.handleChangePage}
                        handleSort = {this.handleSort}
                        header = {this.tableHeader}
                        body = {this.tableBody}
                        clickOnProductionStatus = {this.clickOnProductionStatus}
                    />
                </div>
            
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/delivery/index.js